import { FC } from 'react';

export const SidepanelDarkBlue: FC = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#112331"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="icon icon-tabler icons-tabler-outline icon-tabler-layout-sidebar-left-expand">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" 
       />
  <path d="M9 4v16" 
        />
  <path d="M14 10l2 2l-2 2" 
        />
</svg>

);

export default SidepanelDarkBlue;
